import { useLanguage } from '@/components/utils/useLanguage';
import CarouselWithHeader, { CarouselItem } from '@/components/ui/CarouselWithHeader';
import SliderCard, { categoryImages } from '@/components/home/SliderCard';
import { container, sectionPadding, sectionBgLight } from '@/lib/ds';

export default function CategoriesSection({ categories = [], activities = [], loading = false }) {
  const { language, t } = useLanguage();

  return (
    <section className={`${sectionPadding} ${sectionBgLight}`}>
      <div className={container}>
        <CarouselWithHeader
          title={t('Worauf habt ihr heute Lust?', 'What do you fancy doing today?')}
          subtitle={t('Finde Familienausflüge in Basel, die zu euch passen', 'Find family trips in Basel that suit you')}
          overflowY
        >
          {loading
            ? [...Array(4)].map((_, i) => (
                <CarouselItem key={i} className="pl-4 basis-[193px] md:basis-1/4 lg:basis-1/4">
                  <div className="rounded-2xl shimmer w-[193px] h-[280px] lg:w-full lg:h-[420px]" />
                </CarouselItem>
              ))
            : categories.filter(c => !c.parent_category_id).slice(0, 8).map(category => {
                const name = language === 'en' ? category.name_en || category.name_de : category.name_de;
                return (
                  <CarouselItem key={category.id} className="pl-4 basis-[193px] md:basis-1/4 lg:basis-1/4">
                    <SliderCard
                      to={`/ausflugsideen?kategorie=${category.slug}`}
                      title={name}
                      subtitle={t('Entdecken', 'Discover')}
                      image={categoryImages[category.slug]}
                      count={activities.filter(a => a.category_ids?.includes(category.id)).length}
                      countLabel={t('Ausflüge', 'Trips')}
                    />
                  </CarouselItem>
                );
              })
          }
        </CarouselWithHeader>
      </div>
    </section>
  );
}